import { actionTypes } from "./mainActions";
import { MenuType } from "../../../Application_Constants";
const initialState = {
  selectedMenu: MenuType.MONITOR_ALL,
  isSearchBar: "true",
  isAdd: false,
  searchUser: "",
  searchMonitor: "",
  searchFacility: "",
  monitorDetails: "",
  isRefreshAudio: "",
  facilityDetails: "",
  userManual: false,
  selectedTab: null,
  facilityListRefresh: false,
  facilityName: "",
  isRefreshMonitor: false,
  isRefreshUser: false,
  isRefreshFacility: false,
  isAssociateApi: false,
  isDelete: false,
  isaudioGrid: false,
  monitorListRefresh: false,
  userListRefresh: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_TAB:
      return {
        ...state,
        selectedTab: action.payload
      };

    case actionTypes.CHANGE_SIDE_BAR:
      return {
        ...state,
        selectedMenu: action.payload,
        searchUser: "",
        searchMonitor: "",
        searchFacility: ""
      };
    case actionTypes.SEARCH_BAR:
      return {
        ...state,
        isSearchBar: action.payload
      };
    case actionTypes.CHANGE_FACILITY:
      return {
        ...state,
        selectedFacility: action.payload
      };
    case actionTypes.ADD_USER:
      return {
        ...state,
        isAdd: action.payload
      };
    case actionTypes.REFRESH_MONITOR:
      return {
        ...state,
        isRefreshMonitor: action.payload
      };
    case actionTypes.REFRESH_ASSOCIATE:
      return {
        ...state,
        isAssociateApi: action.payload
      };
    case actionTypes.REFRESH_USER:
      return {
        ...state,
        isRefreshUser: action.payload
      };
    case actionTypes.REFRESH_FACILITY:
      return {
        ...state,
        isRefreshFacility: action.payload
      };
    case actionTypes.SEARCH_USER:
      return {
        ...state,
        searchUser: action.payload
      };
    case actionTypes.SEARCH_FACILITY:
      return {
        ...state,
        searchFacility: action.payload
      };
    case actionTypes.USER_MANUAL:
      return {
        ...state,
        userManual: action.payload
      };
    case actionTypes.SEARCH_MONITOR:
      return {
        ...state,
        searchMonitor: action.payload
      };

    case actionTypes.MONITOR_DETAILS:
      return {
        ...state,
        monitorDetails: action.payload
      };

    case actionTypes.REFRESH_AUDIO:
      return {
        ...state,
        isRefreshAudio: action.payload
      };

    case actionTypes.FACILITY_DETAILS:
      return {
        ...state,
        facilityDetails: action.payload
      };
    case actionTypes.NAV_FUNCTION:
      return {
        ...state,
        navFunction: action.payload
      };
    case actionTypes.FACILITYLIST_REFRESH:
      return {
        ...state,
        facilityListRefresh: action.payload
      };
    case actionTypes.FACILITY_NAME:
      return {
        ...state,
        facilityName: action.payload
      };
    case actionTypes.DELETE_AUDIO:
      return {
        ...state,
        isDelete: action.payload
      };
    case actionTypes.CALL_AUDIOGRID:
      return {
        ...state,
        isaudioGrid: action.payload
      };
    case actionTypes.MONITORLIST_REFRESH:
      return {
          ...state,
          monitorListRefresh: action.payload
      };
    case actionTypes.USERLIST_REFRESH:
      return {
            ...state,
            userListRefresh: action.payload
      };
    default:
      return { ...state };
  }
};
